import { useContext } from "react";

import { AppContext } from '../../context.js';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';

import Animation from '../../files/cubesAnimation.json';

function Spinner(props) {
  const { spiners } = props;

  const context = useContext(AppContext);

  return (
    <div className="card pe-2" style={{position: 'fixed', left: '50%', transform: 'translateX(-50%)', bottom: 20, display: spiners.length > 0 ? 'block' : 'none'}}>
        <div className="d-flex justify-content-start align-items-center">
          <div style={{height: 32, width: 32}}>
            <DotLottieReact
              data={Animation}
              loop
              autoplay
            />
          </div>
          <div className="typo-normal-150">Please wait...</div>
      </div>
    </div>
  );
}

export default Spinner;